import { TargetModel } from './target.model'

export interface FilterItemModel {
  target: TargetModel
  operator: Operator
  values: string[]
}

export enum Operator {
  In, NotIn
}

export enum FilterGD {
  Carrier = "Carrier",
  Year = "Year",
  Month = "Month",
  Day = "Day",
  FastTrack = "Fast Track",
  PlateSearch = "Plate Search",
  PlateSearchLower = "Plate search"
}

export enum SourcePowerBIEnum{
  GD, LPE, PED
}
